export class Monster {

  constructor(monster, setup) {
    this.monster = monster;
    this.setup = setup;
  }

  /**
   * Returns if the currently selected monster is one of the provided ids
   * @param monsterIds
   * @returns {boolean|*}
   */
  isMonster(monsterIds) {
    if (Array.isArray(monsterIds))
      return monsterIds.includes(this.monster.id);

    return this.monster.id === monsterIds
  }

  getLevel(skill) {
    if (this.monster === null)
      return 0;

    return this.monster[`${skill}_level`]
  }

  getSize() {
    if (this.monster === null)
      return 1;

    return this.monster.size
  }

  getDefensiveStat(stat) {
    if (this.monster === null)
      return 0;

    return this.monster[`defence_${stat}`]
  }

  getOffensiveStat(stat) {
    if (this.monster === null)
      return 0;

    return this.monster[`${stat}_strength`]
  }

  getDamageStat(stat) {
    if (this.monster === null)
      return 0;

    return this.monster[`${stat}_damage`]
  }

  /**
   * Checks if the current monster contains given words (OR)
   * @param words
   * @returns {*}
   */
  monsterNameContains(words) {
    if (!Array.isArray(words)) {
      return this.monster.name.toLowerCase().includes(words.toLowerCase())
    }

    for (let i = 0; i < words.length; i++) {
      if (this.monster.name.toLowerCase().includes(words[i].toLowerCase()))
        return true;
    }
    return false;
  }

  monsterDamageCap(currentDamage) {
    if (this.monster === null)
      return currentDamage;

    switch (this.monster.id) {
      case 319: //Corp
        return Math.floor(currentDamage / 2);

      case 2042: //Zulrah
      case 2043:
      case 2044:
        return currentDamage > 50 ? 50 : currentDamage
    }

    return currentDamage;
  }

  isShadeMonster() {
    return this.monsterNameContains("shade")
  }

  isKalphiteMonster() {
    return this.monsterNameContains("kalphite")
  }

  isDemonMonster() {
    if (!this.monster)
      return false;

    let demons = [
      "Abyssal Sire",
      "Abyssal demon",
      "Balfrug Kreeyath",
      "Black demon",
      "Demonic gorilla",
      "Doomion",
      "Greater Nechryael",
      "Greater abyssal demon",
      "Greater demon",
      "Holthion",
      "Ice demon",
      "Infernal pyrelord",
      "Jungle Demon",
      "K'ril Tsutsaroth",
      "Lesser demon",
      "Lesser demon",
      "Nechryael",
      "Nechryarch",
      "Othainian",
      "Pyrelord",
      "Skotizo",
      "Tstanon Karlak",
      "Zakl'n Gritch",
    ];

    return demons.includes(this.monster.name)
  }

  isDragonMonster() {
    if (!this.monster)
      return false;

    let dragons = [
      "Adamant dragon",
      "Alchemical Hydra",
      "Ancient Wyvern",
      "Baby black dragon",
      "Baby blue dragon",
      "Baby green dragon",
      "Baby red dragon",
      "Black dragon",
      "Blue dragon",
      "Bronze dragon",
      "Brutal black dragon",
      "Brutal blue dragon",
      "Brutal green dragon",
      "Brutal red dragon",
      "Drake",
      "Galvek",
      "Great Olm",
      "Green dragon",
      "Hydra",
      "Iron dragon",
      "King Black Dragon",
      "Lava dragon",
      "Long-tailed Wyvern",
      "Mithril dragon",
      "Red dragon",
      "Rune dragon",
      "Skeletal Wyvern",
      "Spitting Wyvern",
      "Steel dragon",
      "Taloned Wyvern",
      "Vorkath",
      "Wyrm",
    ];

    return dragons.includes(this.monster.name)
  }

  isUndeadMonster() {
    if (!this.monster)
      return false;

    let undead = [
      "Aberrant spectre",
      "Abhorrent spectre",
      "Ankou",
      "Asyn Shade",
      "Banshee",
      "Crawling Hand",
      "Crushing hand",
      "Dark Ankou",
      "Deviant spectre",
      "Fiyr Shade",
      "Ghast",
      "Ghost",
      "Giant skeleton",
      "Greater Skeleton Hellhound",
      "Loar Shade",
      "Monkey Zombie",
      "Mummy",
      "Pestilent Bloat",
      "Phrin Shade",
      "Repugnant spectre",
      "Revenant cyclops",
      "Revenant dark beast",
      "Revenant demon",
      "Revenant dragon",
      "Revenant goblin",
      "Revenant hellhound",
      "Revenant hobgoblin",
      "Revenant imp",
      "Revenant knight",
      "Revenant ork",
      "Revenant pyrefiend",
      "Riyl Shade",
      "Screaming banshee",
      "Screaming twisted banshee",
      "Shade",
      "Skeleton",
      "Skeleton Champion",
      "Skeleton Hellhound",
      "Skeleton Mage",
      "Skeleton brute",
      "Skeleton fremennik",
      "Skeleton heavy",
      "Skeleton thug",
      "Skeleton warlord",
      "Skogre",
      "Slash Bash",
      "Summoned Zombie",
      "Tarn",
      "The Draugen",
      "Tortured soul",
      "Trapped Soul",
      "Tree spirit",
      "Twisted Banshee",
      "Undead Druid",
      "Undead Lumberjack",
      "Undead chicken",
      "Undead cow",
      "Undead one",
      "Vet'ion",
      "Vorkath",
      "Zombie",
      "Zombie pirate",
      "Zombie swab",
      "Zombified Spawn",
    ];

    return undead.includes(this.monster.name)
  }
}



// WEBPACK FOOTER //
// ./src/js/monster.js